module.exports = __webpack_public_path__ + "img/grid-shape.a89da8aa.svg";